import * as React from "react";
import Component from "../../AbstractComponent";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import TextField from "../Material/TextField";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Constants from "../../../Action/Constants";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import PersonFactory from "../../../Entity/Factories/PersonFactory";
import * as uuidV4 from "uuid/v4";
import PersonLookup from "../../Partials/Lookup/PersonLookup";

export class CoachNewTenantDialog extends Component {
  public state = {
    activeStep: 0,
    skipped: new Set(),
    openCoachCreateNewTenant: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    disableButtonDuringRequest: false,
    errorFields: [],
    amazonFolderName: uuidV4(),
    firstName: "",
    lastName: "",
    tenantType: "person",
    personTypeForCompanyTenant: "new",
    selectedPersonForCompanyTenant: null,
    tenant: null,
    tenantFirstName: "",
    tenantLastName: "",
    companyNameTenant: "",
    companyTenant: null,
    showNextButton: false,
    isSaving: false,
    isClosePreprocessDialogOpen: false,
    existingTenant: null,
    tenantEmail: "",
    tenantMobilePhone: ""
    };

  constructor(public props) {
    super(props);

  }

  public componentWillMount() {
    this.setState({
      openCoachCreateNewTenant: this.props.openCoachCreateNewTenant,
    });
	}

	public componentWillReceiveProps(nextProps) {
    this.setState({
      openCoachCreateNewTenant: nextProps?.openCoachCreateNewTenant,
      existingTenant: nextProps?.existingTenant
    });
  }

  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openCoachCreateNewTenant: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      disableButtonDuringRequest: false,
      errorFields: [],
      selectedUnit: null,
      amazonFolderName: uuidV4(),
      firstName: "",
      lastName: "",
      tenantType: "person",
      personTypeForCompanyTenant: "new",
      selectedPersonForCompanyTenant: null,
      tenant: null,
      tenantFirstName: "",
      tenantLastName: "",
      companyNameTenant: "",
      companyTenant: null,
      showNextButton: false,
      isSaving: false,
      isClosePreprocessDialogOpen: false,
      existingTenant: null,
      tenantEmail: "",
      tenantMobilePhone: ""
    });
  }

  public onCloseTenantCoach = () => {
    this.clearBackEndErrors();
    setTimeout(() => {this.clearState()}, 100);
    
    if(this.props.onCloseTenantCoach){
      this.props.onCloseTenantCoach.call(this, this.state.existingTenant ? null : (this.state.companyTenant || this.state.tenant));
    }
  }

  /* Main logic for STEPPER */
  // Logic for stepper, use methods when we click button continue on step page, and we start logic.
  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();
    if(activeStep === steps.length - 1) { // it is last step
      this.onCloseTenantCoach();
    } else {
      switch (activeStep) {
        case 0:
          return this.startStepFirst();
        case 1:
          return this.plusOneStep();
      }
    }
  };

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    return [this.trans("coach/newcontract-step/second-title"), this.trans("coach/newtenant-step/second-title")];
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
      </div>
    )
  }

  // Steppers components content

  public firstStepDetails = () => {
    if (this.state.existingTenant) {
      return (
        <div>
          <div>
             <TextField
              autoComplete="off"
              className="form-element full-size"
              type="text"
              label={this.trans("coach/propertyowner-scenario/person-step/third-field/companyname-label")}
              value={this.state.existingTenant?.name}
              onChange={this.sync.bind(this, this.syncronizers.EVENT, "companyNameTenant")}
              variant="standard"
              autoFocus={true}
              disabled
              error={this.getErrorFor("name")}
            />
            {!!this.getErrorFor("name") && <div className="component-error-text">{this.getErrorFor("name")}</div>}
            <p style={{marginTop: "25px"}} className="info-text">
              {this.trans("coach/newtenant-step/tenant-info2")}
            </p>
            <RadioGroup
              className="filters-container"
              value={this.state.personTypeForCompanyTenant}
              onChange={this.choosePersonTypeForCompanyTenant}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                width: "500px",
                paddingLeft: "0px"
              }}
            >
              <FormControlLabel
                control={<Radio color="primary" />}
                value="new"
                label={this.trans("option-new-person")}
                style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
              />
              <FormControlLabel
                control={<Radio color="primary" />}
                value="existing"
                label={this.trans("option-existing-person")}
                style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
              />
            </RadioGroup>
            {
              this.state.personTypeForCompanyTenant === "new" && (
                <React.Fragment>
                  <div style={{display: "flex", width: "100%", margin: "-14px 0"}}>
                    <div style={{ width: "600px", marginRight: "20px"}}>
                      <TextField
                        autoComplete="off"
                        // id="firstName"
                        // name="firstName"
                        className="form-element full-size scroll-to-firstName"
                        type="text"
                        label={this.trans("label-first-name")}
                        value={this.state.tenantFirstName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantFirstName")}
                        variant="standard"
                        error={!!this.getErrorFor("firstName")}
                      />
                      {!!this.getErrorFor("firstName") && <div className="component-error-text">{this.getErrorFor("firstName")}</div>}
                    </div>
                    <TextField
                      autoComplete="off"
                      // id="lastName"
                      // name="lastName"
                      className="form-element full-size scroll-to-lastName"
                      type="text"
                      label={this.trans("label-last-name") + this.trans("field/optional")}
                      value={this.state.tenantLastName}
                      onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantLastName")}
                      variant="standard"
                      error={!!this.getErrorFor("contacts.lastName")}
                    />
                    {!!this.getErrorFor("contacts.lastName") && <div className="component-error-text">{this.getErrorFor("contacts.lastName")}</div>}
                  </div> 
                  <div className="hint-styles-dialog" style={{margin: "10px 0 0 0"}}>
                    {this.trans("coach/newpropertyfirstuser-step/fifth-hintfortenant")}
                  </div>   
                </React.Fragment>
              )
            }
            {
              this.state.personTypeForCompanyTenant === "existing" && (
                <div style={{margin: "-14px 0"}}>
                  <PersonLookup
                    {...this.props}
                    className="form-element full-size scroll-to-generalContactId"
                    autoFocus={false}
                    autoSelectId={this.state.selectedPersonForCompanyTenant?.id ? this.state.selectedPersonForCompanyTenant?.id : null}
                    isInlineBlock={true}
                    width="100%"
                    containerWidth="100%"
                    ref="PersonLookup"
                    floatingLabelText={this.trans("label/company-general-contact")}
                    labelText={this.trans("label/company-general-contact")}
                    onSelect={this.changeGeneralContact}
                    onClear={this.clearGeneralContact}
                    forceUpdatePage={true}
                    disableEntityCreation={true}
                    error={this.state.errorFields.includes("generalContactId") && this.trans("error-this-field-is-required")}
                    styleInModal={"styleInModal"}
                  />
                </div>
              )
            }
          </div>
        </div>   
        );
    } else {
      return (
        <div>
          <div>
            {this.trans("coach/propertyowner-scenario/tenant-step/first-choosetype")}
          </div>
          <RadioGroup
            className="filters-container"
            value={this.state.tenantType}
            onChange={this.chooseTenantType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/propertyowner-radiobutton/person")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/propertyowner-radiobutton/company")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
          </RadioGroup>
          { this.state.tenantType === "person" &&
            <div>
              <p className="info-text">
                {this.trans("coach/newpropertyfirstuser-step/tenant-info1")}
              </p>
              <div style={{display: "flex", width: "100%"}}>
                <div style={{ width: "600px", marginRight: "20px"}}>
                  <TextField
                    autoComplete="off"
                    // id="firstName"
                    // name="firstName"
                    className="form-element full-size scroll-to-firstName"
                    type="text"
                    autoFocus={true}
                    label={this.trans("label-first-name")}
                    value={this.state.tenantFirstName}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantFirstName")}
                    variant="standard"
                    error={!!this.getErrorFor("firstName")}
                  />
                {(!!this.getErrorFor("firstName")) && <div className="component-error-text">{this.getErrorFor("firstName")}</div>}  
                </div>  
              <TextField
                autoComplete="off"
                // id="lastName"
                // name="lastName"
                className="form-element full-size scroll-to-lastName"
                type="text"
                label={this.trans("label-last-name") + this.trans("field/optional")}
                value={this.state.tenantLastName}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantLastName")}
                variant="standard"
                error={!!this.getErrorFor("lastName")}
              />
            </div>
            <div className="hint-styles-dialog">
              {this.trans("coach/newpropertyfirstuser-step/fifth-hintfortenant")}
            </div>
            <TextField
              autoComplete="off"
              className="form-element full-size scroll-to-email"
              label={this.trans("label-email") + this.trans("field/optional")}
              value={this.state.tenantEmail}
              onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantEmail")}
              variant="standard"
              // disabled={this.state.removed}
              error={!!this.getErrorFor("email")}
              helperText={this.getErrorFor("email")}
            />
            <TextField
              autoComplete="off"
              // id="phone1"
              //name="phone1"
              className="form-element full-size scroll-to-phone1"
              type="text"
              label={this.trans("label-mob-number") + this.trans("field/optional")}
              value={this.state.tenantMobilePhone}
              onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantMobilePhone")}
              variant="standard"
              // disabled={this.state.removed}
              error={!!this.getErrorFor("phone1")}
              helperText={this.getErrorFor("phone1")}
            />
          </div>
          }
          {
            this.state.tenantType === "company" && 
            <div>
               <TextField
                autoComplete="off"
                className="form-element full-size"
                type="text"
                label={this.trans("coach/propertyowner-scenario/person-step/third-field/companyname-label")}
                value={this.state.companyNameTenant}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "companyNameTenant")}
                variant="standard"
                autoFocus={true}
                error={this.getErrorFor("name")}
              />
              {!!this.getErrorFor("name") && <div className="component-error-text">{this.getErrorFor("name")}</div>}
              <p style={{marginTop: "25px"}} className="info-text">
                {this.trans("coach/newpropertyfirstuser-step/tenant-info3")}
              </p>
              <div style={{display: "flex", width: "100%"}}>
                <div style={{ width: "600px", marginRight: "20px"}}>
                  <TextField
                    autoComplete="off"
                    // id="firstName"
                    // name="firstName"
                    className="form-element full-size scroll-to-firstName"
                    type="text"
                    label={this.trans("label-first-name")}
                    value={this.state.tenantFirstName}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantFirstName")}
                    variant="standard"
                    error={!!this.getErrorFor("contacts.firstName")}
                  />
                  {!!this.getErrorFor("contacts.firstName") && <div className="component-error-text">{this.getErrorFor("contacts.firstName")}</div>}
                  </div>
                  <TextField
                    autoComplete="off"
                    // id="lastName"
                    // name="lastName"
                    className="form-element full-size scroll-to-lastName"
                    type="text"
                    label={this.trans("label-last-name") + this.trans("field/optional")}
                    value={this.state.tenantLastName}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantLastName")}
                    variant="standard"
                    error={!!this.getErrorFor("contacts.lastName")}
                  />
                  {!!this.getErrorFor("contacts.lastName") && <div className="component-error-text">{this.getErrorFor("contacts.lastName")}</div>}
                </div> 
              <div className="hint-styles-dialog">
                {this.trans("coach/newpropertyfirstuser-step/fifth-hintfortenant")}
              </div> 
              <TextField
                autoComplete="off"
                className="form-element full-size scroll-to-email"
                label={this.trans("label-email") + this.trans("field/optional")}
                value={this.state.tenantEmail}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantEmail")}
                variant="standard"
                // disabled={this.state.removed}
                error={!!this.getErrorFor("email")}
                helperText={this.getErrorFor("email")}
              />
              <TextField
                autoComplete="off"
                // id="phone1"
                //name="phone1"
                className="form-element full-size scroll-to-phone1"
                type="text"
                label={this.trans("label-mob-number") + this.trans("field/optional")}
                value={this.state.tenantMobilePhone}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "tenantMobilePhone")}
                variant="standard"
                // disabled={this.state.removed}
                error={!!this.getErrorFor("phone1")}
                helperText={this.getErrorFor("phone1")}
              />
            </div>
          }
        </div>   
      );
    }          
  }

  public secondStepDetails = () => {
    if(this.state.tenant){
      return (
        <div>
          <div>{this.trans("coach/newpropertyfirstuser-step/fifth-info1")}</div>
          <ul className="success-created-entity-or-error">
          </ul> 
          <ul className="success-created-entity-or-error">
            {this.state.tenantType === "company" && <li>{`${this.trans("coach/propertyowner-field/newcompany-label")} ${this.state.companyTenant?.name}`}</li>}
            {this.state.existingTenant && <li>{`${this.trans("coach/propertyowner-field/newcompany-label")} ${this.state.existingTenant?.name}`}</li>}
            <li>{`${this.trans("coach/propertyowner-field/newperson-label")} ${this.state.tenant?.displayName}`}</li>
            {this.state.tenant.email && <li>{`${this.trans("label-email")}: ${this.state.tenant?.email}`}</li>}
            {this.state.tenant.phone1 && <li>{`${this.trans("label-mob-number")}: ${this.state.tenant?.phone1}`}</li>}
          </ul>       
        </div>
      );
    } 
  }

  //Funcionality for steps
  public startStepFirst = () => {
    return this.tenantStartStepFirst();
  }

  public startStepSecond = () => {
    return this.tenantStartStepSecond();
  }

  //Methods for step logic
  public tenantStartStepFirst = () => {
    if (this.state.personTypeForCompanyTenant === "existing" && !this.state.selectedPersonForCompanyTenant) {
      return this.setState({
        errorFields: ["generalContactId"]
      });
    } 

    if (this.state.personTypeForCompanyTenant === "new") {
      this.createTenant();
    } else {
      this.linkPersonToCompanyTenant();
    }
  }

  public tenantStartStepSecond = () => {
    this.plusOneStep();

    this.setState({
      showNextButton: true
    });
  }

  public changeTenantChoice = (event) => {
    const choice: string = event.target.value;

    this.setState({
      tenantChoice: choice,
      tenant: null,
      firstName: "",
      showNextButton: false
    });
  }

  public contractStartStepThird = () => {
    this.plusOneStep();
  }

  public contractStartStepFourth = () => {
    this.plusOneStep();
  }


  //Methods
  public changeGeneralContact = (person: PersonInterface, isManuallySelected: boolean) => {
    this.setState({
      selectedPersonForCompanyTenant: person,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData
    });
  }

  public clearGeneralContact = () => {
    this.setState({
      selectedPersonForCompanyTenant: null,
      hasModifiedData: true
    });
  }

  public selectTenant = (entity: CompanyInterface | PersonInterface): void => {
    this.setState({
      tenant: entity
    }, () => {
      if (this.state.tenant){
        this.setState({
          showNextButton: true
        })
      }
    });
  }

  public clearTenant = (): void => {
    this.setState({
      tenant: null
    }, () => {
      if (!this.state.tenant){
        this.setState({
          showNextButton: false
        })
      }
    });
  }

  public clearPerson = (): void => {
    this.setState({
      tenant: null
    }, () => {
      if(!this.state.tenant){
        this.setState({
          showNextButton: false
        })
      }
    });
  }

  public selectPerson = (person: PersonInterface): void => {
    this.setState({
      tenant: person
    }, () => {
      if(this.state.tenant){
        this.setState({
          showNextButton: true
        })
      }
    });
  }


  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public clearFieldsError = () => {
    this.setState({
      firstNameError: false,
      companyNameError: false
    })
  }

  public chooseTenantType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      tenantType: choice,
      tenantFirstName: "",
      tenantLastName: "",
      companyNameTenant: "",
      tenantEmail: "",
      tenantMobilePhone: ""
    });
  }

  public choosePersonTypeForCompanyTenant = (event) => {
    const choice: string = event.target.value;

    this.setState({
      personTypeForCompanyTenant: choice,
      selectedPersonForCompanyTenant: null,
      tenantFirstName: "",
      tenantLastName: "",
      errorFields: []
    });
  }
   
  public getPayloadTenant = (): any => {
    const pageTemplate = this.state.existingTenant ? "person" : "tenant";

    return {
      person: {
        firstName: this.state.tenantFirstName,
        lastName: this.state.tenantLastName,
        profession: "",
        email: this.state.tenantEmail,
        phone1: this.state.tenantMobilePhone,
        phone2: "",
        contactRoleId: null,
        mainBankAccountId: "",
        companyId: this.state.existingTenant?.id || null,
        address: {
          formattedAddress: ""
        },
        dateOfBirth: null,
        placeOfBirth: {
          formattedAddress: ""
        },
        identityNumber: "",
        identityType: 255,
        amazonFolderName: "",
        note: "",
        pageTemplate: pageTemplate,
        genderTypeId: 3,
        languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
      }
    };
  }

  public getPayloadForPerson = (type): any => {
    let pageTemplate = type;
    return {
      firstName: type === "tenant" ? this.state.tenantFirstName : this.state.firstName,
      lastName:  type === "tenant" ? this.state.tenantLastName : this.state.lastName,
      profession: "",
      email: type === "tenant" && this.state.tenantEmail,
      phone1: type === "tenant" && this.state.tenantMobilePhone,
      phone2: "",
      contactRoleId: null,
      mainBankAccountId: "",
      companyId: null,
      address: {
        formattedAddress: ""
      },
      dateOfBirth: null,
      placeOfBirth: {
        formattedAddress: ""
      },
      identityNumber: "",
      identityType: 255,
      amazonFolderName: "",
      note: "",
      pageTemplate: pageTemplate,
      genderTypeId: 3,
      languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
    };
  }


  public createTenant = () => {
    this.setState({
      errorFields: [] //need for clear error for occupant fields
    }, () => {
      if (this.state.tenantType === "person") {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
            payload: this.getPayloadTenant(),
            onSuccess: person => {
              this.setState({
                isSaving: false,
                tenant: person,
                showNextButton: true,
                errorFields: []
              }, () => {
                if (!this.state.errorFields.length) {
                  this.plusOneStep();
                } 
              });
            },
            onError: (error) => {
              this.setState({
                isSaving: false,
                errorFields: error.fields,
              });
            }
          });
        });
      } else {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
            payload: {
              company: {
                name: this.state.companyNameTenant,
                email: "",
                phone: "",
                mainBankAccountId: "",
                address: null,
                amazonFolderName: "",
                note: "",
                pageTemplate: "company",
                contacts: this.state.tenantType === "company" ? {
                  ...this.getPayloadForPerson("tenant")
                } : undefined
              }
            },
            onSuccess: (company) => {
              const tenant = PersonFactory.create(company?.data?.contacts?.[0]);

              this.setState({
                companyTenant: company,
                tenant: tenant,
                showNextButton: true,
                errorFields: [],
                isSaving: false
              }, () => {
                if (!this.state.errorFields.length) {
                  this.plusOneStep();
                }
              })
            },
            onError: (error) => {
              this.setState({
                errorFields: error.fields,
                isSaving: false
              })
            }
          });
        });
      }
    })
  }

  public linkPersonToCompanyTenant = () => {
    this.setState({
      errorFields: [] //need for clear error for occupant fields
    }, () => {
      this.saving(() => {
        this.props.dispatch({
          type: Constants.GLOBAL_COMPANY_ADD_PERSON,
          payload: {
            id: this.state.existingTenant?.id,
            person: this.state.selectedPersonForCompanyTenant,
            companyIds: [{id: this.state.existingTenant?.id, role: ""}]
          },
          onSuccess: person => {
            this.setState({
              isSaving: false,
              tenant: person,
              showNextButton: true,
              errorFields: []
            }, () => {
              if (!this.state.errorFields.length) {
                this.plusOneStep();
              } 
            });
          },
          onError: (error) => {
            this.setState({
              isSaving: false,
              errorFields: error.fields,
            });
          }
        });
      });
    })
  }

  public closePreprocessDilaogOpen = () => {
    this.setState({
      isClosePreprocessDialogOpen: false
    });
  }

  public renderContent = () => {
    const steps = this.getSteps();
    const { activeStep } = this.state;

    return (
      <div className="stepper-wrapper">
        <div className="stepper-container">
        { activeStep !== steps.length &&
          <Stepper activeStep={activeStep}>
            {steps.map((label) => {
              const props = {};
              const labelProps = {};
              return (
                <Step key={label} {...props}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        }
        <div>
          <div className="step-content-wrapper unit-coach ">
            {this.getStepContent(activeStep)}
          </div>
        </div>
      </div>
      { activeStep !== steps.length &&
        <div className={`step-content-button-wrapper button-container ${(activeStep === steps.length - 1) && this.state.tenant ? "without-cancel" : ""}`}>
          { !this.state.tenant &&
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                this.setState({
                  isClosePreprocessDialogOpen: true
                })
              }}
              className="cancel-button"
            >
            {this.trans("dialog-button/close")}
            </Button>
          }

          <div>
            {
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleNext}
              >
              {activeStep === steps.length - 1 ? this.trans("dialog-button/close") : this.trans("coach/propertyowner-button/next")}
            </Button>
            }
          </div>
        </div>
      }
    </div>
    )
  }

  public render() {
    return (
      <div>
        <Dialog
          className={`dialog dialog-window dialog-assistant coach-new-tenant coach-new-presentation has-button-padding ${this.props.innerDialogClasses}`}
          open={this.state.openCoachCreateNewTenant}
          onClose={this.onCloseTenantCoach}
          disableBackdropClick={true}
        >
          <DialogContent>
            {this.renderContent()}
          </DialogContent>
        </Dialog>

        <PageTransition isSaving={this.state.isSaving} />

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention")}
          content={
            <div style={{width: "calc(100% - 65px)"}}>
            {this.trans("are-you-sure")
            }
            </div>
          }
          openLeavePrompt={this.state.isClosePreprocessDialogOpen}
          onClose={this.closePreprocessDilaogOpen}
          onlyPositiveButton={true}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={false}
          hideCross={true}
          actions={
            [(
              <Button
              key="modal-cancel-btn"
              color="primary"
              onClick={this.closePreprocessDilaogOpen}
              style={{height: "34px", width: "auto" }}
              >
                {this.trans("label-no")}
              </Button>
            ),
            (
              <Button
              key="modal-add-btn"
              variant="contained"
              color="primary"
              onClick={this.onCloseTenantCoach}
              style={{height: "34px", width: "auto" }}
              >
                {this.trans("label-yes")}
              </Button>
            )]
          }
        />
      </div>
    );
  }
}
